import {
  Box,
  Typography as Typo,
  Card as MuiCard,
  useTheme,
  styled,
  TypographyProps,
  Skeleton,
} from '@mui/material';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {PasswordComponent} from './innerComponents/ChangePassword';
import {EmailAddressComponent} from './innerComponents/ChangeEmail';
import {
  DeavtivateComponent,
  DeleteComponent,
} from './innerComponents/DeleteDeactivate';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const Card = styled(MuiCard)(({theme}) => ({
  borderRadius: theme.spacing(2),
}));

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

const AccountSettingWidget = (props: {loading: boolean}) => {
  const {loading} = props;
  const isLarge = useIsLargeDevice();

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 4,
          marginLeft: {md: 2},
        }}
      >
        <Box>
          {isLarge && (
            <Typography
              // component={injectAsChild ? 'p' : 'h1'}
              display="flex"
              fontSize={{xxs: 16, md: 20}}
              fontWeight={{xxs: 600, md: 500}}
              m={2}
              mb={1}
              mt={3}
              sx={{
                wordWrap: 'break-word',
                textTransform: 'capitalize',
              }}
            >
              Account Settings
            </Typography>
          )}
          <Box mt={isLarge ? 0 : 3}>
            {loading ? (
              <Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  {[
                    ...new Array(5).fill('').map(() => (
                      <>
                        <Skeleton
                          variant="rounded"
                          width={'100%'}
                          height={10}
                          sx={{
                            my: 0.5,
                          }}
                        />
                      </>
                    )),
                  ]}
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} mb={4} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  {[
                    ...new Array(5).fill('').map(() => (
                      <>
                        <Skeleton
                          variant="rounded"
                          width={'100%'}
                          height={10}
                          sx={{
                            my: 0.5,
                          }}
                        />
                      </>
                    )),
                  ]}
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
              </Box>
            ) : (
              <>
                <EmailAddressComponent />
                <PasswordComponent />
                <DeavtivateComponent />
                <DeleteComponent />
              </>
            )}
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default AccountSettingWidget;
